import { Tabs } from "expo-router";
import { useResolveClassNames, useCSSVariable } from "uniwind";
import { Search, Home, User } from "lucide-react-native";
import { FloatingTabBar } from "@/shared/components/ui/floating-tab-bar";

export default function TabLayout() {
  const headerStyle = useResolveClassNames("bg-card");
  const [headerTintColor] = useCSSVariable(["--color-brand"]) as [string];

  return (
    <Tabs
      initialRouteName="index"
      tabBar={(props) => <FloatingTabBar {...props} />}
      screenOptions={{
        headerStyle: headerStyle as { backgroundColor?: string },
        headerTintColor,
      }}
    >
      <Tabs.Screen
        name="search"
        options={{
          title: "Search",
          headerShown: false,
          tabBarIcon: ({ color, size }) => <Search size={size} color={color} />,
        }}
      />
      <Tabs.Screen
        name="index"
        options={{
          title: "Events",
          headerShown: false,
          tabBarIcon: ({ color, size }) => <Home size={size} color={color} />,
        }}
      />
      <Tabs.Screen
        name="profile"
        options={{
          title: "Profile",
          headerShown: false,
          tabBarIcon: ({ color, size }) => <User size={size} color={color} />,
        }}
      />
    </Tabs>
  );
}
